import React from 'react';
import { HeroSection } from './components/HeroSection';
import { SocialProofSection } from './components/SocialProofSection';
import { PainSection } from './components/PainSection';
import { ProductSection } from './components/ProductSection';
import { UrgencySection } from './components/UrgencySection';
import { PricingSection } from './components/PricingSection';
import { MoreTestimonialsSection } from './components/MoreTestimonialsSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FAQSection } from './components/FAQSection';
import { CostSection } from './components/CostSection';
import { FinalCTASection } from './components/FinalCTASection';
export function App() {
  return <div className="min-h-screen bg-secondary font-sans text-gray-900 overflow-x-hidden" data-id="element-0">
      <main data-id="element-1">
        <HeroSection data-id="element-2" />
        <SocialProofSection data-id="element-3" />
        <PainSection data-id="element-4" />
        <ProductSection data-id="element-5" />
        <UrgencySection data-id="element-6" />
        <PricingSection data-id="element-7" />
        <MoreTestimonialsSection data-id="element-8" />
        <GuaranteeSection data-id="element-9" />
        <FAQSection data-id="element-10" />
        <CostSection data-id="element-11" />
        <FinalCTASection data-id="element-12" />
      </main>

      <footer className="bg-gray-900 text-gray-400 py-8 text-center text-sm" data-id="element-13">
        <div className="max-w-4xl mx-auto px-4" data-id="element-14">
          <p className="mb-2" data-id="element-15">
            © {new Date().getFullYear()} REINICIO INTERNO. Todos los derechos
            reservados.
          </p>
          <p className="text-xs opacity-60" data-id="element-16">
            Este producto no sustituye el consejo médico profesional. Consulte a
            su médico antes de comenzar cualquier programa de salud.
          </p>
        </div>
      </footer>
    </div>;
}